{
  "cashier": "Касса",
  "depositTab": "Депозит",
  "withdrawTab": "Шығару",
  "historyTab": "Тарих",
  "secureNote": "Қауіпсіз және шифрланған",
  "selectMethod": "Төлем әдісін таңдаңыз",
  "amount": "Сома",
  "amountPlaceholder": "Соманы енгізіңіз",
  "quickAmounts": "Жылдам сомалар",
  "continue": "Жалғастыру",
  "depositNow": "Депозит жасау",
  "withdrawNow": "Шығару сұрауы",
  "methodDisabled": "Бұл әдіс әзірге белсенді емес",
  "methodsPending": "Төлем реквизиттерін әкімші әлі баптамаған",
  "receiptRequired": "Түбіртек жүктеу қажет — түбіртек төлем растауы емес",
  "adminVerification": "Баланс тек тәуелсіз админ тексеруінен кейін артады",
  "noCryptoNetworks": "Крипто желілері бапталмаған",
  "noAddress": "Депозит мекенжайы әлі тағайындалмаған",
  "cardToCard": "Картадан картаға",
  "cardToCardDesc": "Банк картасына аударым",
  "m10": "M10",
  "m10Desc": "M10 аударымы",
  "terminal": "Терминал",
  "terminalDesc": "Терминал төлемі",
  "crypto": "Kriptovalyuta",
  "cryptoDesc": "Крипто депозит",
  "bankCardWithdraw": "Банк картасы",
  "m10Withdraw": "M10",
  "cryptoWithdraw": "Крипто",
  "minMax": "Мин {{min}} — Макс {{max}}",
  "trustInstant": "Бапталғанда жылдам өңдеу",
  "trustSecure": "Қауіпсіз операциялар",
  "trustMethods": "Карта, M10, Терминал, Крипто",
  "historyEmpty": "Транзакция жоқ",
  "historyAuth": "Тарихты көру үшін кіріңіз",
  "balanceTitle": "Баланс",
  "openCashier": "Касса",
  "topUp": "Толықтыру",
  "bonusAccount": "Бонус шоты",
  "reservedFunds": "Резерв",
  "copyId": "ID көшіру",
  "loginRequired": "Жалғастыру үшін кіріңіз",
  "region": "Төлем аймағы",
  "instructionsSoon": "Реквизит тағайындалғаннан кейін нұсқаулар осында пайда болады",
  "uploadReceipt": "Түбіртек жүктеу",
  "uploadDisabled": "Депозит сұрауы жасалмай тұрып түбіртек қабылданбайды",
  "depositCreated": "Депозит сұрауы жасалды",
  "receiptUploaded": "✅ Чек жүктелді. Төлем өтінімі тіркелді. Күтіңіз.",
  "withdrawReserved": "Шығару резервтелді",
  "destination": "Алушы деректері",
  "destinationRequired": "Алушы деректерін енгізіңіз",
  "noCvv": "CVV және PIN қажет емес және қабылданбайды",
  "status": "Күйі",
  "copy": "Көшіру",
  "bankPayment": "Банк төлемі",
  "currentBalance": "Ағымдағы баланс: {{amount}}",
  "copied": "Көшірілді",
  "selectCoin": "Монета",
  "selectNetwork": "Желі",
  "timeRemaining": "Қалған уақыт",
  "depositExpired": "Бұл депозит сұрауының мерзімі өтті. Жаңасын жасаңыз.",
  "cancelDeposit": "Сұрауды болдырмау",
  "qrLabel": "Депозит мекенжайының QR",
  "copyAddress": "Мекенжай",
  "cardHolder": "Карта иесі (міндетті емес)",
  "sendExactAmount": "Көрсетілген соманы дәл жіберіңіз. Қате желі немесе сома есептелмейді.",
  "noPairsConfigured": "Монета/желі жұбы әлі бапталмаған",
  "depositCancelled": "Депозит сұрауы болдырылмады",
  "usdRate": "1 USD = {{rate}} AZN",
  "minUsd": "Мин ${{usd}}",
  "saveQr": "QR сақтау",
  "networkWarning": "Тек {{network}} желісіне жіберіңіз. Қате желі қаражаттың жоғалуына әкелуі мүмкін.",
  "filter_all": "Барлығы",
  "filter_deposit": "Депозит",
  "filter_withdrawal": "Шығару",
  "field_card_number": "Карта нөмірі",
  "field_card_holder": "Карта иесі",
  "field_bank_name": "Банк",
  "field_m10_account": "M10 шоты",
  "field_account_holder": "Шот иесі",
  "field_terminal_code": "Терминал коды",
  "field_address": "Мекенжай",
  "field_asset": "Монета",
  "field_network": "Желі",
  "field_memo": "Memo",
  "field_phone": "Телефон",
  "field_iban": "IBAN",
  "field_name": "Аты",
  "methodSelected_card_to_card": "Картадан картаға төлем таңдалды",
  "methodSelected_m10": "M10 төлемі таңдалды",
  "methodSelected_terminal": "Терминал арқылы төлем таңдалды",
  "methodSelected_crypto": "Криптовалюта таңдалды",
  "cryptoUnavailable": "Крипто депозит әлі дайын емес",
  "cryptoUnavailableHint": "Қабылдау мекенжайы мен желі әкімшіде бапталмаған. Қаражат жібермеңіз — жалған әмиян көрсетілмейді.",
  "quotePreview": "Бағам",
  "expectedCredit": "Күтілетін AZN кредит",
  "estimatedCrypto": "Шамамен крипто сомасы",
  "adminRateNote": "Бұл курс әкімші тағайындаған, нарықтық баға емес.",
  "enterAmountFirst": "Алдымен соманы енгізіңіз, содан кейін монета мен желіні таңдаңыз.",
  "status_waiting_for_payment": "Төлем күтілуде",
  "status_detected": "Аударым анықталды",
  "status_awaiting_confirmations": "Растаулар күтілуде",
  "status_pending_review": "Тексеру күтілуде",
  "status_confirmed": "Расталды",
  "status_expired": "Мерзімі өтті",
  "status_ambiguous": "Қолмен тексеру қажет",
  "status_error": "Қате / қолдау жоқ",
  "status_cancelled": "Бас тартылды",
  "status_rejected": "Қабылданбады",
  "status_approved": "Расталды",
  "expiredLateNote": "Мерзімі өткеннен кейін де желідегі аударым келуі мүмкін. Ол автоматты кредиттелмейді және тексерілетін шолуды қажет етеді.",
  "enlargeQr": "QR-ды үлкейту",
  "closeQr": "Жабу",
  "confirmationTimeNote": "10 минуттық таймер — өтінімнің күту терезесі, блокчейн растауы емес.",
  "usdEquivalent": "USD баламасы: ${{usd}}",
  "quoteUnavailable": "Бағам қолжетімсіз. Сома мен желіні тексеріңіз.",
  "depositRequests": "Депозит өтінімдері",
  "networkMismatch": "Тек көрсетілген желіге жіберіңіз.",
  "safeRecovery": "Байланыс үзілді. Соңғы сақталған өтінім қалпына келтіріледі.",
  "historyAll": "Барлығы",
  "historyDeposit": "Депозит",
  "historyWithdrawal": "Қаражат шығару",
  "historyEmptyTitle": "Операциялар тарихы бос",
  "historyEmptyDescription": "Депозиттеріңіз бен шығару өтінімдеріңіз осында көрсетіледі.",
  "historyBankDeposit": "Банк депозиті",
  "statusPending": "Күтуде",
  "statusReview": "Тексерілуде",
  "statusApproved": "Расталды",
  "statusPaid": "Төленді",
  "statusCompleted": "Аяқталды",
  "statusRejected": "Қабылданбады",
  "statusExpired": "Мерзімі бітті",
  "statusCancelled": "Болдырылмады",
  "statusFailed": "Сәтсіз",
  "withdrawAcceptedClean": "Қаражат шығару өтініміңіз қабылданып, тексеруге жіберілді.",
  "selectBankLocal": "Банкті таңдаңыз",
  "holderFullNameLocal": "Карта иесінің аты-жөні",
  "recipientCardLocal": "Алушының карта нөмірі",
  "availableBalanceLocal": "Қолжетімді баланс",
  "backWithdrawalLocal": "Артқа — шығару әдістері",
  "withdrawDetailsLocal": "Шығару деректерін енгізіңіз",
  "paymentMethodsLocal": "Төлем әдістері",
  "paymentAmountLocal": "Төлем сомасы",
  "transactionTypeLocal": "Операция түрі",
  "walletSectionsLocal": "Әмиян бөлімдері",
  "cryptoTransferTitle": "Криптовалюталық депозит",
  "cryptoTransferAmount": "Жіберілетін сома",
  "cryptoOrderAmount": "Тапсырыс сомасы",
  "cryptoTransferAddress": "Әмиян мекенжайы",
  "cryptoTransferNetwork": "Желі",
  "cryptoShowQr": "QR-кодты ашу",
  "cryptoQrWaiting": "QR-код қолжетімсіз",
  "cryptoNoAddress": "Мекенжай жоқ. Қаражат жібермеңіз.",
  "cryptoWarnNetwork": "Тек {{asset}} валютасын {{network}} желісі арқылы жіберіңіз. Қате желіде қаражат жоғалуы мүмкін.",
  "cryptoWarnAmount": "Сома мен желі комиссиясын тексеріңіз. Жеткіліксіз аударым есепке алынбауы мүмкін.",
  "cryptoMoreInfo": "Қосымша ақпарат",
  "cryptoMemo": "Memo / Tag",
  "prevStep": "Алдыңғы қадам",
  "depositAmount": "Депозит сомасы",
  "paymentInstruction": "Төлем нұсқаулығы",
  "paymentConfirm": "Төлемді растау",
  "depositStages": "Депозит кезеңдері",
  "stageAmount": "Сома",
  "stagePayment": "Төлем",
  "stageReceipt": "Чек",
  "receiptSend": "Чек жіберу",
  "rejected": "Қабылданбады",
  "network": "Желі",
  "paymentNote": "Төлем жазбасы",
  "extraPaymentInfo": "Қосымша төлем мәліметі",
  "invalidAmount": "Дұрыс сома енгізіңіз.",
  "tapToSelect": "Таңдау үшін түртіңіз",
  "walletLabel": "Әмиян",
  "previewBanner": "СЫНАҚ РЕЖИМІ: Барлық төлем карталары таңдалады. Нақты ақша жібермеңіз; депозит/шығару орындалмайды.",
  "otherBank": "Басқа банк",
  "cryptoAsset": "Криптовалюта",
  "receiveAddress": "Қабылдау мекенжайы",
  "notAssigned": "Тағайындалмаған",
  "paymentMethod": "Төлем әдісі",
  "bank": "Банк",
  "recipient": "Алушы",
  "cardNumber": "Карта нөмірі",
  "qrWhenReady": "QR тек нақты мекенжай болғанда көрсетіледі",
  "qrInactive": "QR белсенді емес",
  "qrInactiveHint": "Мекенжай тағайындалғанда осында шығады.",
  "networkAttention": "Назар: {{network}} желісі",
  "networkAttentionBody": "Тек таңдалған желі мекенжайына жіберіңіз. Қате желі немесе сома қаражат жоғалтуына әкелуі мүмкін.",
  "minDepositFees": "Минималды депозит және комиссия",
  "minDepositFeesBody": "Жіберместен бұрын минимум мен комиссияны тексеріңіз.",
  "waitingTransfer": "Аударымды күтеміз",
  "waitingTransferBody": "Тек расталған реквизиттерге дәл сомамен төлеңіз.",
  "wrongTransfer": "Қате аударымдар туралы",
  "wrongTransferBody": "Басқа банкке/картаға немесе басқа сомаға төлем есептелмеуі мүмкін.",
  "previewNoAddress": "СЫНАҚ · МЕКЕНЖАЙ ЖОҚ · АҚША ЖІБЕРМЕҢІЗ",
  "addReceiptTitle": "Төлем чегін қосыңыз",
  "addReceiptBody": "Камера/галерея/файл. Сынақта серверге жіберілмейді.",
  "cameraCapture": "Камерамен түсіру",
  "sampleTimer": "Үлгі таймер — нақты өтінім жоқ",
  "transferDetails": "Аударым мәліметтері",
  "paymentDetailsStep": "Төлем мәліметтері",
  "paymentConfirmStep": "Төлемді растау",
  "iPaidReceipt": "Мен төледім · Чек экраны",
  "fromGallery": "Галереядан таңдау",
  "chooseFile": "Файл таңдау",
  "cameraFileSelected": "Камера файлы таңдалды: {{name}}. Сынақта серверге жүктелмейді.",
  "imageSelected": "Сурет таңдалды: {{name}}. Сынақта серверге жүктелмейді.",
  "fileSelected": "Файл таңдалды: {{name}}. Сынақта серверге жүктелмейді.",
  "previewTest": "Сынақ",
  "fileNotUploaded": "Файл серверге жүктелмейді",
  "bankSelect": "Банк таңдау",
  "depositBonusSample": "Депозит бонусы · үлгі",
  "checkFinalAmount": "Соңғы соманы жасалған тапсырыстан тексеріңіз.",
  "orderNumber": "Тапсырыс нөмірі:",
  "amountDue": "Төленетін сома:",
  "requestProcessing": "Өтінім өңделуде",
  "paymentCreated": "Төлем өтінімі сәтті жасалды!",
  "completeTransferHint": "Төмендегі төлем мәліметтерімен аударымды аяқтаңыз.",
  "exactAmountWarn": "Назар! Тек көрсетілген соманы дұрыс мәліметтермен жіберіңіз.",
  "uploadReceiptAfter": "Аударымнан кейін чекті жүктеңіз.",
  "paymentInfo": "Төлем мәліметтері",
  "cardHolderName": "Карта иесінің аты",
  "receiverName": "Алушының аты",
  "accountNumber": "Шот нөмірі",
  "previewDepositSelected": "СЫНАҚ: {{method}} — {{amount}} AZN таңдалды. Нақты депозит жоқ; ақша жібермеңіз.",
  "previewWithdrawChecked": "СЫНАҚ: {{method}} бойынша {{amount}} AZN шығару тексерілді. Нақты өтінім жоқ.",
  "checkingFileSelection": "Файл таңдауын тексереміз",
  "bonusSampleLine": "5%: {{bonus}} · қорытынды: {{total}}",
  "phoneNumber": "Телефон нөмірі",
  "addressLabel": "мекенжайы",
  "uploadReceiptReminder": "Төлемнен кейін чекті жүктеуді ұмытпаңыз.",
  "previewWithdrawBanner": "СЫНАҚ: Нақты шығару жіберілмейді және баланс өзгермейді.",
  "cardExpiry": "Карта мерзімі (Ай/Жыл)",
  "checkRequest": "Өтінімді тексеру",
  "bonusNotOnReal": "Нақты балансқа есептелмейді.",
  "realBalance": "Нақты баланс",
  "gameCurrencies": "Ойын валюталары",
  "walletCta": "Әмиян",
  "closeGameFirst": "Белсенді ойынды жабыңыз — ашық ставка бар. Содан кейін валютаны өзгертіңіз.",
  "regionLabel": "Төлем аймағы",
  "regionCryptoOnly": "Бұл аймақта тек крипто төлемдер қолжетімді",
  "tonConnectTitle": "TON Connect арқылы депозит",
  "tonConnectWallet": "TON әмиянын қосу",
  "tonPayConfirm": "Төлемді әмиянда растаңыз",
  "tonDisconnectWallet": "Әмиянды ажырату",
  "tonWalletStatus": "Әмиян күйі",
  "tonWalletNotConnected": "Қосылмаған",
  "tonWalletConnected": "Қосылған · {{address}}",
  "tonWalletConnectedHint": "TON әмияныңыз сәтті байланыстырылды.",
  "tonWalletDisconnected": "Әмиян ажыратылды.",
  "tonWalletConnectFailed": "Әмиянды қосу сәтсіз аяқталды.",
  "tonConnectWalletFirst": "Алдымен TON әмиянын қосыңыз.",
  "tonConfirmInWallet": "Төлемді әмияныңызда растаңыз.",
  "tonPendingAdminReview": "Депозит өтініші жасалды. Төлем әкімші тексеруін күтуде.",
  "tonDepositCreated": "TON депозит өтініші жасалды. Әмиян арқылы төлемді аяқтаңыз.",
  "tonPaymentCancelled": "Төлем болдырмады немесе аяқталмады.",
  "tonPaymentMissing": "Төлем деректері жоқ. Қайта көріңіз.",
  "tonPaymentProofMissing": "Әмиян төлем дәлелін қайтармады. Төлем өтпесе, қайта көріңіз.",
  "tonWarnNativeOnly": "Тек native TON жіберіңіз. Басқа токен немесе желі қаражат жоғалтуына әкелуі мүмкін.",
  "tonWarnAdminReview": "Әмиян растауы баланс толықтыру емес. Баланс әкімші тексеруінен кейін артады.",
  "gameCurrency": "Ойын валютасы"
}
